import axios, { AxiosResponse } from 'axios'

const API_URL_NEW = process.env.REACT_APP_API_URL_NEW
const LOCATION_LIST_URL = `${API_URL_NEW}/location/allLocations`

const locationListApi = (search: any): Promise<any> => {
    return axios
        .get(`${LOCATION_LIST_URL}?page=1&perPage=20&search=${search}`)
        .then((d: AxiosResponse<any>) => d.data)
}

// New API for lowest price offers for all product groups
 const getLowestPriceOffersForAllProductGroups = (destination_location_id: string, qty: string): Promise<any> => {
  return axios
    .get(`${API_URL_NEW}/offer/lowest-price-offers-for-all-product-groups`, {
      params: { destination_location_id, qty }
    })
    .then((d: AxiosResponse<any>) => d.data)
}

export {  locationListApi, getLowestPriceOffersForAllProductGroups }
